module.exports = __webpack_public_path__ + "img/ewm_big.c82effee.jpg";